module.exports = __webpack_public_path__ + "img/paperclip.c84266c7.svg";